import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { theme } from "@shared/designSystem/theme";
import RemergeApi from "@shared/http/RemergeApi";
import { RemergeAPIProvider } from "@shared/http/remergeApiContext";
import HttpService from "@shared/services/HttpService";
import { TrackingProvider } from "@shared/services/TrackingContext";
import trackingService from "@sherlock-ui/services/tracking";
type AppContextProps = React.PropsWithChildren<{}>;

const httpService = new HttpService(import.meta.env.VITE_API_HOST as string);
const remergeApi = new RemergeApi(httpService);

export default function AppContext(props: AppContextProps) {
  return (
    <RemergeAPIProvider value={remergeApi}>
      <TrackingProvider value={trackingService}>
        <ThemeProvider theme={theme}>
          <StyledEngineProvider injectFirst>{props.children}</StyledEngineProvider>
        </ThemeProvider>
      </TrackingProvider>
    </RemergeAPIProvider>
  );
}
